import React, { Component } from "react";
import PropTypes from "prop-types";
import Styles from "./tracking-map.module.scss";
import cameraIcon from "./camera.svg";

const contextTypes = {
    viewport: PropTypes.object,
    isDragging: PropTypes.bool,
};


export default class CameraFovOverlay extends Component {
   
    render() {
        const { viewport } = this.context;
        const { width, height } = viewport;
        const pixelRatio = window.devicePixelRatio || 1;

        const { fieldOfView, video } = this.props;
        
        const position = video.details.Data.CameraLocation;
        const angle = position.rot + Math.PI - (viewport.bearing * (Math.PI / 180)); // Offset by 180deg
        const [x, y] = viewport.project([position.lon, position.lat]);

        const distance = 300 * 1.414;

        const firstX = (Math.cos(angle + (-fieldOfView / 2)) * distance) + x;
        const firstY = (Math.sin(angle + (-fieldOfView / 2)) * distance) + y;

        const secondX = (Math.cos(angle + (fieldOfView / 2)) * distance) + x;
        const secondY = (Math.sin(angle + (fieldOfView / 2)) * distance) + y;
        
        const polygonPoints = `${x},${y} ${firstX},${firstY} ${secondX},${secondY}`

        return (
            <svg 
                width={width * pixelRatio}
                height={height * pixelRatio}
                style={{
                    width: `${width}px`,
                    height: `${height}px`,
                    position: "absolute",
                    pointerEvents: "none",
                    left: 0,
                    top: 0,
                }}
            >
                <polygon points={polygonPoints} className={Styles.fovPolygon}/>
                <circle cx={x} cy={y} r={10} className={Styles.fovCameraPos} />
                <image className={Styles.fovCameraIcon} xlinkHref={cameraIcon} height="10" width="10" x={x} y={y}/>
            </svg>
        );
    }
}

CameraFovOverlay.displayName = "CameraFovOverlay";
CameraFovOverlay.contextTypes = contextTypes;

CameraFovOverlay.defaultProps = {
    // 94.4 deg H fov
    // from https://gopro.com/help/articles/Question_Answer/HERO4-Field-of-View-FOV-Information
    fieldOfView: 94.4 * (Math.PI / 180),
}



// WEBPACK FOOTER //
// ./src/components/tracking-map/camera-fov-overlay.js